import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import { buildRedirectUrl } from 'services/redirect_helpers.js'
import { affiliatizeLinks } from 'services/impact_stat.js'

import styles from './event-link.scss'

export default class EventLink extends React.Component {
  _trackLinkClick = () => {
    const { eventId } = this.props

    if (window.mixpanel) {
      window.mixpanel.track(
        'Join Meeting Tapped (Web)',
        { event_id: eventId }
      )
    }
  }

  componentDidMount () {
    affiliatizeLinks()
  }

  componentDidUpdate () {
    affiliatizeLinks()
  }

  _renderThumbnail () {
    const { link, isMeetingLink } = this.props

    const containerClass = classnames(styles['thumbnail-container'], {
      [styles['thumbnail-container-meeting-link']]: isMeetingLink
    })

    return <div className={containerClass}>
      <img src={link.image_url} />
    </div>
  }

  _renderLinkWithDetails () {
    const { link } = this.props
    return <div className={styles['link-with-details']}>
      {link.image_url ? this._renderThumbnail() : null}
      <div className={styles['details']}>
        <div className={styles['title']}>
          {link.title}
        </div>
        <div className={styles['details-link']}>
          {link.url}
        </div>
      </div>
    </div>
  }

  _renderPlainLink () {
    const { link } = this.props
    return <div className={styles['plain-link']}>
      {link.url}
    </div>
  }

  render () {
    const { link, isMeetingLink } = this.props
    const url = buildRedirectUrl(link.url)

    const containerClass = classnames(styles['container'], {
      [styles['container-meeting-link']]: isMeetingLink
    })

    return <a className={containerClass} href={url} target='_blank' onClick={this._trackLinkClick}>
      {link.title ? this._renderLinkWithDetails() : this._renderPlainLink()}
    </a>
  }
}

EventLink.propTypes = {
  link: PropTypes.object,
  isMeetingLink: PropTypes.bool,
  eventId: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/details/EventLink.jsx